export default __webpack_public_path__ + "static/media/rif-id-manager.7afc1cbb.svg";